import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
//Common Functions
import { api } from "../../../common/CloudService/ApiPromisify";
import { CloudService } from "../../../common/CloudService/ClientLibsReference";
import { LoadScreen } from "../../Common/LoadScreen";
import * as fo from "../../../common/FormatFunctions";

export class Categorys extends Component {
  constructor() {
    super();
    this.state = {
      //Loading
      loaded: false,
      editLoaded: true,
      //Display
      categorySelected: false,
      categoryEdited: false,
      categoryAdded: false,
      categoryDeleted: false,
      //Details
      selectedCatalogueId: "",
      categoryList: [],
      selectedCategory: "",
      selectedCategoryId: "",
      selectedCategoryLastUpdatedDateTime: "",
      selectedCategoryName: "",
      selectedCategoryDescription: "",
      //Edit Details
      editedCategoryId: "",
      editedCategoryLastUpdatedDateTime: "",
      editedCategoryName: "",
      editedCategoryDescription: ""
      //Other
    };
  }

  componentDidMount = () => {
    this.getCategorys();
  };

  getCategorys = async () => {
    let categoryRequest = new CloudService.CategoryRequest();
    categoryRequest.codeTag = localStorage.getItem("codeTag");
    categoryRequest.userId = localStorage.getItem("userId");
    categoryRequest.catalogueId = localStorage.getItem("catalogueId");

    this.setState({ selectedCatalogueId: localStorage.getItem("catalogueId") });

    await api("categoryApiV1CategoryGetByCatalogueId", categoryRequest).then(
      res => {
        let categoryResponse = CloudService.CategoryResponse.constructFromObject(
          res.data
        );
        console.log(categoryResponse);

        if (categoryResponse.errorCode === 0) {
          this.setState(
            {
              categoryList: categoryResponse.categoryList
            },
            () => {
              console.log(this.state.categoryList);
              this.reselectCategory();
            }
          );
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "An error occured retrieving categorys, please refresh and try again",
            life: 3000
          });
        }
      }
    );

    this.setState({ loaded: true, editLoaded: true });
  };

  updateCategory = async () => {
    this.setState({ editLoaded: false });

    let categoryRequest = new CloudService.CategoryRequest();
    categoryRequest.codeTag = localStorage.getItem("codeTag");
    categoryRequest.userId = localStorage.getItem("userId");
    categoryRequest.id = this.state.editedCategoryId;
    categoryRequest.lastUpdatedDateTime = this.state.editedCategoryLastUpdatedDateTime;
    categoryRequest.name = this.state.editedCategoryName;
    categoryRequest.description = this.state.editedCategoryDescription;

    await api("categoryApiV1CategoryUpdate", categoryRequest).then(res => {
      let categoryResponse = CloudService.CategoryResponse.constructFromObject(
        res.data
      );
      console.log(categoryResponse);

      if (categoryResponse.errorCode === 0) {
        this.setState({
          categoryEdited: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Category successfully updated",
          life: 3000
        });
        let typeOfUpdate = 1;
        this.updateCategoryList(categoryResponse, typeOfUpdate);
      } else {
        this.setState({ editLoaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured updating the category, please try again",
          life: 3000
        });
      }
    });
  };

  addCategory = async () => {
    this.setState({ editLoaded: false });

    let categoryRequest = new CloudService.CategoryRequest();
    categoryRequest.codeTag = localStorage.getItem("codeTag");
    categoryRequest.userId = localStorage.getItem("userId");
    categoryRequest.catalogueId = this.state.selectedCatalogueId;
    categoryRequest.name = this.state.editedCategoryName;
    categoryRequest.description = this.state.editedCategoryDescription;

    await api("categoryApiV1CategoryCreate", categoryRequest).then(res => {
      let categoryResponse = CloudService.CategoryResponse.constructFromObject(
        res.data
      );
      console.log(categoryResponse);

      if (categoryResponse.errorCode === 0) {
        this.setState({
          categoryEdited: false,
          categoryAdded: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Category successfully created",
          life: 3000
        });
        let typeOfUpdate = 2;
        this.updateCategoryList(categoryResponse, typeOfUpdate);
      } else {
        this.setState({ editLoaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured creating the category, please try again",
          life: 3000
        });
      }
    });
  };

  deleteCategory = async () => {
    this.setState({ loaded: false });

    let categoryRequest = new CloudService.CategoryRequest();
    categoryRequest.codeTag = localStorage.getItem("codeTag");
    categoryRequest.userId = localStorage.getItem("userId");
    categoryRequest.id = this.state.selectedCategoryId;
    categoryRequest.lastUpdatedDateTime = this.state.selectedCategoryLastUpdatedDateTime;

    await api("categoryApiV1CategoryDelete", categoryRequest).then(res => {
      let categoryResponse = CloudService.CategoryResponse.constructFromObject(
        res.data
      );
      console.log(categoryResponse);

      if (categoryResponse.errorCode === 0) {
        this.setState({
          categorySelected: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Category successfully deleted",
          life: 3000
        });
        let typeOfUpdate = 3;
        this.updateCategoryList(categoryResponse, typeOfUpdate);
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured deleting the category, please try again",
          life: 3000
        });
      }
    });
  };

  updateCategoryList = (apiResponse, type) => {
    let categoryList = this.state.categoryList;
    let i = 0;

    if (type === 2) {
      categoryList.push({
        id: apiResponse.id,
        lastUpdatedDateTime: apiResponse.lastUpdatedDateTime,
        name: this.state.editedCategoryName,
        description: this.state.editedCategoryDescription
      });
    } else {
      this.state.categoryList.forEach(e => {
        if (apiResponse.id === e.id || this.state.selectedCategoryId === e.id) {
          if (type === 1) {
            categoryList[i].lastUpdatedDateTime =
              apiResponse.lastUpdatedDateTime;
            categoryList[i].name = this.state.editedCategoryName;
            categoryList[i].description = this.state.editedCategoryDescription;
          }

          if (type === 3) {
            categoryList.splice(i, 1);
          }
        }
        i++;
      });
    }

    this.setState(
      { categoryList: categoryList, loaded: true, editLoaded: true },
      () => {
        console.log(this.state.categoryList);
        this.reselectCategory();
      }
    );
  };

  selectCategory = data => {
    this.setState(
      {
        selectedCategory: data,
        selectedCategoryId: data.id,
        selectedCategoryLastUpdatedDateTime: data.lastUpdatedDateTime,
        selectedCategoryName: data.name,
        selectedCategoryDescription: data.description
      },
      () => {
        console.log(this.state.selectedCategory);
      }
    );
  };

  editCategory = () => {
    if (this.state.categoryAdded === true) {
      this.setState({
        editedCategoryId: "",
        editedCategoryLastUpdatedDateTime: "",
        editedCategoryName: "",
        editedCategoryDescription: ""
      });
    } else {
      this.setState({
        editedCategoryId: this.state.selectedCategoryId,
        editedCategoryLastUpdatedDateTime: this.state
          .selectedCategoryLastUpdatedDateTime,
        editedCategoryName: this.state.selectedCategoryName,
        editedCategoryDescription: this.state.selectedCategoryDescription
      });
    }
  };

  reselectCategory = () => {
    if (this.state.selectedCategory) {
      this.state.categoryList.forEach(e => {
        if (this.state.selectedCategoryId === e.id) {
          this.setState(
            {
              categorySelected: true,
              categoryEdited: false,
              categoryAdded: false
            },
            () => {
              this.selectCategory(e);
            }
          );
        }
      });
    }
  };

  checkRequiredFields = () => {
    let disable = false;

    if (this.state.editedCategoryName && this.state.editedCategoryDescription) {
      disable = false;
    } else {
      disable = true;
    }

    return disable;
  };

  render() {
    const s = this.state;

    return (
      <div
        className="ui-g dashboard"
        style={s.editLoaded === false ? { pointerEvents: "none" } : {}}
      >
        <pr.Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />
        <pr.Dialog
          header="Delete Category"
          footer={
            <div>
              <pr.Button
                className="secondary-btn"
                label="Yes"
                icon="pi pi-check"
                onClick={() => {
                  this.setState({ categoryDeleted: false });
                  this.deleteCategory();
                }}
                style={{
                  float: "right"
                }}
              />
              <pr.Button
                className="secondary-btn"
                label="No"
                icon="pi pi-times"
                onClick={() => {
                  this.setState({ categoryDeleted: false });
                }}
                style={{
                  float: "right"
                }}
              />
            </div>
          }
          visible={s.categoryDeleted}
          style={{ width: "50vw" }}
          modal={true}
          onHide={e => this.setState({ categoryDeleted: false })}
        >
          Are you sure you want to delete?
        </pr.Dialog>

        {s.loaded === false ? (
          <LoadScreen />
        ) : (
          <div className="ui-g-12">
            {/*Card*/}
            {s.categorySelected === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>Unique Id: </b>
                    <label>
                      {fo.formatId(s.selectedCategoryId) || "Not Set"}
                    </label>
                  </div>
                  <div className="ui-g-6">
                    <b>Category LUDT: </b>
                    <label>
                      {JSON.stringify(s.selectedCategoryLastUpdatedDateTime) ||
                        "Not Set"}
                    </label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>Name: </b>
                    <label>{s.selectedCategoryName || "Not Set"}</label>
                  </div>
                  <div className="ui-g-6">
                    <b>Description: </b>
                    <label>{s.selectedCategoryDescription || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <pr.Button
                    label="Edit"
                    icon="pi pi-plus"
                    onClick={() => {
                      this.setState(
                        {
                          categorySelected: false,
                          categoryEdited: true,
                          categoryAdded: false
                        },
                        () => {
                          this.editCategory();
                        }
                      );
                    }}
                    style={{ float: "right" }}
                  />
                  <pr.Button
                    label="Delete"
                    icon="pi pi-trash"
                    onClick={() => {
                      this.setState({ categoryDeleted: true });
                    }}
                    style={{ float: "right" }}
                  />
                  <pr.Button
                    className="secondary-btn"
                    label="Close"
                    icon="pi pi-times"
                    onClick={() => {
                      this.setState({
                        categorySelected: false,
                        categoryEdited: false,
                        categoryAdded: false
                      });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Editing Card*/}
            {s.categoryEdited === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedCategoryName || ""}
                        onChange={e =>
                          this.setState({
                            editedCategoryName: e.target.value
                          })
                        }
                      />
                      <label className="input-label">Name *</label>
                    </span>
                  </div>
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedCategoryDescription || ""}
                        onChange={e =>
                          this.setState({
                            editedCategoryDescription: e.target.value
                          })
                        }
                      />
                      <label className="input-label">Description *</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <pr.Button
                    disabled={this.checkRequiredFields()}
                    label="Save"
                    icon={
                      s.editLoaded === false
                        ? "pi pi-spin pi-spinner"
                        : "pi pi-check"
                    }
                    onClick={() => {
                      s.categoryAdded === true
                        ? this.addCategory()
                        : this.updateCategory();
                    }}
                    style={{
                      float: "right"
                    }}
                  />
                  <pr.Button
                    className="secondary-btn"
                    label="Cancel"
                    icon="pi pi-times"
                    onClick={() => {
                      s.categoryAdded === true
                        ? this.setState({
                            categorySelected: false,
                            categoryEdited: false,
                            categoryAdded: false
                          })
                        : this.setState({
                            categorySelected: true,
                            categoryEdited: false,
                            categoryAdded: false
                          });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Table*/}
            <div className="ui-g-12 card">
              <pr.DataTable
                value={s.categoryList}
                selectionMode="single"
                onSelectionChange={e => {
                  this.setState(
                    {
                      categorySelected: true,
                      categoryEdited: false,
                      categoryAdded: false
                    },
                    () => {
                      this.selectCategory(e.data);
                    }
                  );
                }}
                selection={s.selectedCategory}
                header={
                  <div className="ui-g">
                    <div className="ui-g-12">
                      <pr.Button
                        className="secondary-btn"
                        label="Create New"
                        icon="pi pi-pencil"
                        onClick={() => {
                          this.setState(
                            {
                              categorySelected: false,
                              categoryEdited: true,
                              categoryAdded: true,
                              selectedCategory: ""
                            },
                            () => {
                              this.editCategory();
                            }
                          );
                        }}
                        style={{ float: "right" }}
                      />
                    </div>
                    <div className="ui-g-12">
                      <label className="header-label">Categorys</label>
                    </div>
                  </div>
                }
                emptyMessage="No Categorys"
                rows={100}
                autoLayout={true}
                paginator={true}
                alwaysShowPaginator={true}
              >
                <pr.Column
                  field="name"
                  header="Name"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="description"
                  header="Description"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
              </pr.DataTable>
              <div className="ui-g-12">
                <pr.Button
                  className="secondary-btn"
                  label="Back"
                  onClick={() => {
                    window.location = "#/catalogue";
                  }}
                  style={{ float: "right" }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Catalogues/legacy/Categories.js